import { ButtonSizes, ButtonStyles, MenuButton } from '@silverfort/sf-components';

const ContentHeaderLoader = () => (
    <div className="border-b border-sf-gray-100">
        <div className="h-16 px-6 py-2 flex justify-between items-center">
            <div className="animate-pulse flex gap-2 items-center">
                <div className="h-6 w-[81px] rounded-[4px] bg-sf-gray-100" />
                <div className="h-6 w-[52px] rounded-[4px] bg-sf-gray-100" />
            </div>
            <MenuButton
                disabled
                className="left-[-120px]"
                iconClassName="text-sf-gray-400"
                buttonStyle={ButtonStyles.Tertiary}
                buttonSize={ButtonSizes.Medium}
                openByDefault={false}
                content={null}
            />
        </div>
        <div className="animate-pulse px-6 pb-4 flex gap-2 flex-wrap">
            <div className="h-6 w-[135px] rounded-[4px] bg-sf-gray-100" />
            <div className="h-6 w-[135px] rounded-[4px] bg-sf-gray-100" />
            <div className="h-6 w-[135px] rounded-[4px] bg-sf-gray-100" />
        </div>
    </div>
);

export default ContentHeaderLoader;
